<div v-if="options">
    un texte tout bidon pour tester<br>
    {{options}}
    <input-frame v-model="options.test"></input-frame>

    <select></select>
</div>